







import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import buildTokenMixin from '@/Admin/TicketTemplate/TokenMixin';
import { CommandToken } from '@/Admin/TicketTemplate/Types';
import I18nMixin from '@/Shared/I18nMixin';
import { SetFont, FontSize } from './Types';

export default mixins(I18nMixin, buildTokenMixin<SetFont>()).extend({
    components: {
        EnumSelector: () => import('@/Shared/EnumSelector.vue'),
    },
    data() {
        return {
            FontSize
        };
    },
    computed: {
        i18nPrefix() {
            return 'admin.ticketTemplateBuilder.commandToken.commands';
        },
    }
});
